import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPieChart2"><Path d="M14 2C15.0506 2 16.0909 2.20693 17.0615 2.60896C18.0321 3.011 18.914 3.60028 19.6569 4.34315C20.3997 5.08602 20.989 5.96793 21.391 6.93853C21.7931 7.90914 22 8.94943 22 10L14 10V2Z" fill="currentColor"/><Path d="M20 13C20 17.9706 15.9706 22 11 22C6.02944 22 2 17.9706 2 13C2 8.02944 6.02944 4 11 4C11.338 4 11.6717 4.01863 12 4.05493V12H19.9451C19.9814 12.3283 20 12.662 20 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPieChart2;
